import { t } from 'i18next';
import { LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import { createRef, Ref } from 'lit/directives/ref.js';

import { ConfigurationPrintOptionDto2, PersonalizationDto } from '@/api-sdk';
import { FgPersonalisation } from '@/components';
import {
  ConfigurationContextType,
  global,
  GlobalComponentType,
  GlobalConfigurationContext,
  personalisation,
  PersonalisationType,
} from '@/context';
import { PersonalisationTypes } from '@/types';
import { consume } from '@lit/context';

type Constructor<T> = { new (...args: any[]): T };

export const PrintOptionMixin = <T extends Constructor<LitElement>>(
  superClass: T,
) => {
  class PrintOptionMixinClass extends superClass {
    fgPersonalisationDialogRef: Ref<FgPersonalisation> = createRef();

    /**
     * Object containing the printOption data
     *
     * @property {Object} printOption
     */
    @property({ type: Object })
    printOption?: ConfigurationPrintOptionDto2;

    @consume({ context: GlobalConfigurationContext })
    configurationContext!: ConfigurationContextType;

    @consume({ context: global.context })
    globalContext!: GlobalComponentType;

    @consume({ context: personalisation.context, subscribe: true })
    personalisationContext: PersonalisationType[] = [];

    getPersonalisation(
      logo?: string | null,
      personalization?: PersonalizationDto | null,
    ): PersonalisationTypes {
      return {
        text: {
          title: t('labels.text'),
          description: personalization?.textPersonalization?.text,
          fontFamily: personalization?.textPersonalization?.font || undefined,
        },
        image: {
          title: t('labels.file'),
          logo: logo as string,
        },
        text_image: {
          title: t('labels.fileAndText'),
          logo: logo as string,
          description: personalization?.textPersonalization?.text,
          fontFamily: personalization?.textPersonalization?.font || undefined,
        },
      };
    }

    openPersonalisationDialog() {
      this.fgPersonalisationDialogRef.value?.openDialog();
    }
  }

  return PrintOptionMixinClass;
};
